module.exports = {
  VERSION: '',
  createDashboard: require('./api/create-dashboard')
};



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/index.js
// module id = 399
// module chunks = 0 2